import type { RefObject } from 'react';
import { findTransitionController } from 'util/core-transition-component';

interface HeaderRotatingShapeRefs {
  titleTopLeftRef: RefObject<HTMLHeadingElement | null>;
  titleBottomRightRef: RefObject<HTMLHeadingElement | null>;
  titleBottomRightMaskRef: RefObject<HTMLHeadingElement | null>;
  titleTopLeftMaskRef: RefObject<HTMLHeadingElement | null>;
}

export function setupTransitionInTimeline(
  timeline: gsap.core.Timeline,
  {
    titleTopLeftRef,
    titleBottomRightRef,
    titleTopLeftMaskRef,
    titleBottomRightMaskRef,
  }: HeaderRotatingShapeRefs,
): void {
  const titleTopLeftController = findTransitionController(titleTopLeftRef);
  const titleTopLeftMaskController = findTransitionController(titleTopLeftMaskRef);

  const titleBottomRightController = findTransitionController(titleBottomRightRef);
  const titleBottomRightMaskController = findTransitionController(titleBottomRightMaskRef);
  if (titleTopLeftController) {
    timeline.add(titleTopLeftController?.getTimeline('in') as gsap.core.Timeline);
  }

  timeline.addLabel('startTopLeftMaskIn', '-=0');

  if (titleTopLeftMaskController) {
    timeline.add(titleTopLeftMaskController?.getTimeline('in') as gsap.core.Timeline, '<');
  }

  if (titleBottomRightController) {
    timeline.add(
      titleBottomRightController?.getTimeline('in') as gsap.core.Timeline,
      'startTopLeftMaskIn+=0.2',
    );
  }

  if (titleBottomRightMaskController) {
    timeline.add(titleBottomRightMaskController?.getTimeline('in') as gsap.core.Timeline, '<0.1');
  }
}

export function setupTransitionOutTimeline(
  timeline: gsap.core.Timeline,
  {
    titleTopLeftRef,
    titleBottomRightRef,
    titleTopLeftMaskRef,
    titleBottomRightMaskRef,
  }: HeaderRotatingShapeRefs,
): void {
  const titleTopLeftController = findTransitionController(titleTopLeftRef);
  const titleTopLeftMaskController = findTransitionController(titleTopLeftMaskRef);

  const titleBottomRightController = findTransitionController(titleBottomRightRef);
  const titleBottomRightMaskController = findTransitionController(titleBottomRightMaskRef);

  if (titleTopLeftController) {
    timeline.add(titleTopLeftController?.getTimeline('out') as gsap.core.Timeline);
  }

  timeline.addLabel('outComplete', '-=0');

  if (titleBottomRightController) {
    timeline.add(
      titleBottomRightController?.getTimeline('out') as gsap.core.Timeline,
      'outComplete',
    );
  }

  if (titleTopLeftMaskController) {
    timeline.add(titleTopLeftMaskController?.getTimeline('out') as gsap.core.Timeline, 0);
  }

  if (titleBottomRightMaskController) {
    timeline.add(
      titleBottomRightMaskController?.getTimeline('out') as gsap.core.Timeline,
      'outComplete',
    );
  }
}
